const API_URL = process.env.REACT_APP_API_URL || "";

export async function logClientError(
  token: string,
  message: string,
  source: string,
  err?: unknown
) {
  try {
    const stack =
      err instanceof Error ? err.stack : err ? String(err) : undefined;
    await fetch(`${API_URL}/api/clientlog`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ message, source, stack, url: window.location.href }),
    });
  } catch {
    // Silently fail — don't let error logging cause more errors
  }
}
